import { ActionTypes } from "redux/reducers/inventoryStatus/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import {
    PROYECT,
    api_get,
    api_post,
    api_delete,
    api_put,
} from "services/api";

const {
    GET_INVENTORY_STATUS_NFC,
    GET_INVENTORY_STATUS_CLOSED,
    GET_INVENTORY_STATUS_REASONS,
    GET_INVENTORY_STATUS_PERCENTAGES,
    GET_INVENTORY_STATUS_COMPLETE,
    GET_INVENTORY_STATUS_INCOMPLETE,
    // GET_INVENTORY_STATUS_SYNC,
    CLOSE_INVENTORY_STATUS,
    CREATE_INVENTORY_STATUS,
    EDIT_INVENTORY_STATUS,
    DELETE_INVENTORY_STATUS,
    SET_INVENTORY_STATUS_FILTERS,
    CLEAR_INVENTORY_STATUS,
} = ActionTypes


export const getInventoryStatusNfc = () => {
    const url = `${process.env.REACT_APP_URL}${PROYECT}/nfc_tags`
    return async (dispatch) => {
        dispatch(startRequestComp('loadingInventoryStatus'))
        await api_get(url).then(resp => {
            dispatch({
                type: GET_INVENTORY_STATUS_NFC,
                payload: resp
            })
        }).catch(error => {
            dispatch(setSnackbar(error))
        })
        dispatch(stopRequestComp('loadingInventoryStatus'))
    }
}

export const getInventoryStatusReasons = () => {
    const url = `${process.env.REACT_APP_URL}${PROYECT}/inventory-reasons`
    return async (dispatch) => {
        dispatch(startRequestComp('loadingInventoryStatus'))
        await api_get(url).then(resp => {
            dispatch({
                type: GET_INVENTORY_STATUS_REASONS,
                payload: resp
            })
        }).catch(error => {
            dispatch(setSnackbar(error))
        })
        dispatch(stopRequestComp('loadingInventoryStatus'))
    }
}

export const getInventoryStatusPercentages = (station, date, unitTypes) => {
    const unitTypesParams = unitTypes.map(unitType => unitType.label).join(',')
    const paramsString = `?date=${date}&idStation=${station}&unitTypes=${unitTypesParams}`
    const url = `${process.env.REACT_APP_URL}${PROYECT}/route-closure-digital-inventories/station-percents${paramsString}`
    return async (dispatch) => {
        dispatch(startRequestComp('loadingInventoryStatus'))
        await api_get(url).then(resp => {
            dispatch({
                type: GET_INVENTORY_STATUS_PERCENTAGES,
                payload: resp
            })
        }).catch(error => {
            dispatch(setSnackbar(error))
        })
        dispatch(stopRequestComp('loadingInventoryStatus'))
    }
}

export const getInventoryStatusIsClosed = (station, date, unitType) => {
    const paramsString = `?idStation=${station}&date=${date}`
    const url = `${process.env.REACT_APP_URL}${PROYECT}/station-daily-inventory-closures${paramsString}`
    return async (dispatch) => {
        dispatch(startRequestComp('loadingInventoryStatus'))
        await api_get(url).then(resp => {
            dispatch({
                type: GET_INVENTORY_STATUS_CLOSED,
                payload: resp
            })
            dispatch(getInventoryStatusPercentages(station, date, unitType))
            dispatch(getInventoryStatusComplete(station, date, unitType))
            dispatch(getInventoryStatusIncomplete(station, date, unitType))
        }).catch(error => {
            dispatch(setSnackbar(error))
            dispatch({ type: GET_INVENTORY_STATUS_PERCENTAGES, payload: { percentage: 0 } })
            dispatch({ type: GET_INVENTORY_STATUS_COMPLETE, payload: [] })
            dispatch({ type: GET_INVENTORY_STATUS_INCOMPLETE, payload: [] })
        })
        dispatch(stopRequestComp('loadingInventoryStatus'))
    }
}

export const getInventoryStatusComplete = (station, date, unitTypes) => {
    const unitTypesParams = unitTypes.map(unitType => unitType.label).join(',')
    const paramsString = `?date=${date}&idStation=${station}&unitTypes=${unitTypesParams}`
    const url = `${process.env.REACT_APP_URL}${PROYECT}/route-closure-digital-inventories/complete-units${paramsString}`
    return async (dispatch) => {
        dispatch(startRequestComp('loadingInventoryStatus'))
        await api_get(url).then(resp => {
            dispatch({
                type: GET_INVENTORY_STATUS_COMPLETE,
                payload: resp
            })
        }).catch(error => {
            dispatch(setSnackbar(error))
        })
        dispatch(stopRequestComp('loadingInventoryStatus'))
    }
}

export const getInventoryStatusIncomplete = (station, date, unitTypes) => {
    const unitTypesParams = unitTypes.map(unitType => unitType.label).join(',')
    const paramsString = `?date=${date}&idStation=${station}&unitTypes=${unitTypesParams}`
    const url = `${process.env.REACT_APP_URL}${PROYECT}/route-closure-digital-inventories/incomplete-units${paramsString}`
    return async (dispatch) => {
        dispatch(startRequestComp('loadingInventoryStatus'))
        await api_get(url).then(resp => {
            dispatch({
                type: GET_INVENTORY_STATUS_INCOMPLETE,
                payload: resp
            })
        }).catch(error => {
            dispatch(setSnackbar(error))
        })
        dispatch(stopRequestComp('loadingInventoryStatus'))
    }
}

export const createInventoryStatus = (body, station, date, unitType, onClose) => {
    const url = `${process.env.REACT_APP_URL}${PROYECT}/route-closure-digital-inventories`
    return async (dispatch) => {
        dispatch(startRequestComp('loadingInventoryStatus'))
        await api_post(url, body).then(resp => {
            dispatch({
                type: CREATE_INVENTORY_STATUS,
                payload: resp?.inventory
            })
            dispatch(setSnackbar(resp?.message || "Inventario creado con éxito", "success"))
            dispatch(getInventoryStatusPercentages(station, date, unitType))
            onClose && onClose()
        }).catch(error => {
            dispatch(setSnackbar(error))
        })
        dispatch(stopRequestComp('loadingInventoryStatus'))
    }
}

export const editInventoryStatus = (body, station, date, unitType, onClose) => {
    const url = `${process.env.REACT_APP_URL}${PROYECT}/route-closure-digital-inventories/${body?.id}`
    return async (dispatch) => {
        dispatch(startRequestComp('loadingInventoryStatus'))
        await api_put(url, body).then(resp => {
            dispatch({
                type: EDIT_INVENTORY_STATUS,
                payload: resp?.inventory
            })
            dispatch(setSnackbar(resp?.message || "Inventario editado con éxito", "success"))
            dispatch(getInventoryStatusPercentages(station, date, unitType))
            onClose && onClose()
        }).catch(error => {
            dispatch(setSnackbar(error))
        })
        dispatch(stopRequestComp('loadingInventoryStatus'))
    }
}

export const deleteInventoryStatus = (id, idReason, unit, idUnit, station, date, unitType, onClose) => {
    const url = `${process.env.REACT_APP_URL}${PROYECT}/route-closure-digital-inventories/${id}`
    return async (dispatch) => {
        dispatch(startRequestComp('loadingInventoryStatus'))
        await api_delete(url, { idInventoryReason: idReason }).then(resp => {
            dispatch({
                type: DELETE_INVENTORY_STATUS,
                payload: {
                    id,
                    unit,
                    idUnit,
                    ...resp?.inventory
                }
            })
            dispatch(setSnackbar(resp?.message || "Inventario eliminado con éxito", "success"))
            dispatch(getInventoryStatusPercentages(station, date, unitType))
            onClose && onClose()
        }).catch(error => {
            dispatch(setSnackbar(error))
        })
        dispatch(stopRequestComp('loadingInventoryStatus'))
    }
}

export const getInventoryStatusSyncWarehouse = (idStation, close = null) => {
    const url = `${process.env.REACT_APP_URL}${PROYECT}/route-closure-digital-inventories/storages/${idStation}`
    return async (dispatch) => {
        dispatch(startRequestComp('loadingInventoryStatus'))
        await api_post(url).then(resp => {
            close && close(false)
            dispatch(setSnackbar(resp.message ? resp.message : 'Inventario de almacenes sincronizado con éxito', resp?.count === 0 ? 'warning' : 'success'))
        }).catch(error => {
            dispatch(setSnackbar(error))
        })
        dispatch(stopRequestComp('loadingInventoryStatus'))
    }
}

export const closeInventoryStatus = (form, onClose) => {
    const url = `${process.env.REACT_APP_URL}${PROYECT}/station-daily-inventory-closures`
    return async (dispatch) => {
        dispatch(startRequestComp('loadingInventoryStatus'))
        await api_post(url, form).then(resp => {
            dispatch({
                type: CLOSE_INVENTORY_STATUS,
                payload: resp?.closure
            })
            dispatch(setSnackbar(resp?.message, 'success'))
        }).catch(error => {
            dispatch(setSnackbar(error))
        })
        onClose()
        dispatch(stopRequestComp('loadingInventoryStatus'))
    }
}

export const reopenInventoryStatus = (id, status = 'reopen', onClose) => {
    const url = `${process.env.REACT_APP_URL}${PROYECT}/station-daily-inventory-closures/${id}/${status}`
    return async (dispatch) => {
        dispatch(startRequestComp('loadingInventoryStatus'))
        await api_put(url).then(resp => {
            dispatch({
                type: CLOSE_INVENTORY_STATUS,
                payload: resp?.closure
            })
            dispatch(setSnackbar(resp?.message, 'success'))
        }).catch(error => {
            dispatch(setSnackbar(error))
        })
        onClose()
        dispatch(stopRequestComp('loadingInventoryStatus'))
    }
}

export const setInventoryStatusFilters = (key = "", data) => ({
    type: SET_INVENTORY_STATUS_FILTERS,
    payload: { data, key }
})

export const clearInventoryStatus = () => ({
    type: CLEAR_INVENTORY_STATUS,
})